// extracted by mini-css-extract-plugin
export default {"headerContainer":"FaqPageHeader_headerContainer__IOJDX"};